"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _AlignmentPicker = _interopRequireDefault(require("./AlignmentPicker"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _FaICIconMap = require("./../../../FaICIconMap");

require("./../../ToolbarButtonWrapper.css");

require("./Textalign.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AlignmentButtons = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(AlignmentButtons, _PureComponent);

  function AlignmentButtons() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      return event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      e.preventDefault();

      _this.props.onOverrideContent(_AlignmentPicker["default"]);
    });

    return _this;
  }

  var _proto = AlignmentButtons.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      onMouseDown: this.onMouseDown,
      className: "toolbarButtonWrapper"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      onClick: this.onClick.bind(this),
      className: "toolbarButton"
    }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.IcIcon, {
      icon: _FaICIconMap.faAlignLeft
    })));
  };

  return AlignmentButtons;
}(_react.PureComponent);

var _default = AlignmentButtons;
exports["default"] = _default;
module.exports = exports.default;